import * as type from '../types/contact';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestContact = actionCreator(type.REQUEST_CONTACT);
export var successContact = actionCreator(type.SUCCESS_CONTACT);
export var failureContact = actionCreator(type.FAILURE_CONTACT);
export var resetContact = actionCreator(type.RESET_CONTACT);